import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import CartContext from "../../context/cart";
import UserContext from "../../context/user";
import { computePartial } from "../../utils/partial";

const useCartRequestCreateMutation = () => {
  const { callApi } = useContext(UserContext);
  const { setCartRequest, handleNext } = useContext(CartContext);

  return useMutation(
    ({ survey, campaignId, cartId }) =>
      callApi(`/cart/request/create/${campaignId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          contentId: Number(cartId),
          surveyAnswer: {
            contentId: Number(survey.contentId),
            ...computePartial(survey, {}),
          },
        }),
      }),
    {
      onSuccess: (data) => {
        setCartRequest(data);
        if (data?.surveySubmission?.submissionId) {
          handleNext(data?.surveySubmission?.submissionId);
        }
      },
    }
  );
};

export default useCartRequestCreateMutation;
